document.addEventListener("DOMContentLoaded", () => {
	const postLayouts = document.querySelectorAll(".post_article");
	
	postLayouts.forEach((postLayout) => {
		
	});
});